import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider';

export interface NewsItem {
  id: number;
  title: string;
  category?: string;
  image?: string;
  imageAlt?: string;
  published_at?: string;
  slug: string;

}

export interface NewsResponse {
  data: NewsItem[];
}

export function useHomepageNews() {
  const lang = useLocale();
  return useQuery<NewsResponse>({
    queryKey: ['homepage-news', lang],
    enabled: true,
    queryFn: async () => {
      const res = await http.get(`/api/news-activities?lang=${lang}&per_page=3&sort=-published_at`);
      const rawData = res.data?.data ?? [];

      const mapImage = (image: unknown): string | undefined => {
        if (typeof image === 'string') return image;
        if (image && typeof image === 'object' && 'url' in image && typeof (image as { url?: unknown }).url === 'string') {
          return (image as { url?: string }).url;
        }
        return undefined;
      };

      const DEFAULT_NEWS_IMAGE = '/images/illustration/social-funding.jpeg';

      const normalized = rawData.map((item: any): NewsItem => ({
        id: item.id,
        title: item.title,
        category: item.category || 'News',
        image: mapImage(item.image) || DEFAULT_NEWS_IMAGE,
        imageAlt: item.image_alt || item.imageAlt || item.title,
        published_at: item.published_at,
        slug: item.slug,
      }));

      return { data: normalized } satisfies NewsResponse;
    },
  });
}
